import type { RouteRecordRaw } from 'vue-router';
import FullLayout from '@/layouts/full/FullLayout.vue';

export const produtosRoutes: RouteRecordRaw[] = [
  {
    path: '/produtos',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Catálogo de Produtos - Hub' },
    children: [
      {
        path: '',
        name: 'ProdutosCatalogo',
        component: () => import('@/views/Produtos/ProdutosCatalogo.vue'),
        meta: { title: 'Catálogo de Produtos', breadcrumb: 'Produtos' },
      },
      {
        path: 'novo',
        name: 'ProdutoNovo',
        component: () => import('@/views/Produtos/ProdutoNovo.vue'),
        meta: { title: 'Novo Produto', breadcrumb: 'Novo' },
      },
      {
        path: ':id(\\d+)',
        name: 'ProdutoDetalhe',
        component: () => import('@/views/Produtos/ProdutoDetalhe.vue'),
        props: true,
        meta: { title: 'Detalhe do Produto', breadcrumb: 'Produto' },
      },
      {
        path: ':id(\\d+)/editar',
        name: 'ProdutoEditar',
        component: () => import('@/views/Produtos/ProdutoNovo.vue'),
        props: true,
        meta: { title: 'Editar Produto', breadcrumb: 'Editar' },
      },
      {
        path: ':id(\\d+)/midias',
        name: 'ProdutoMidias',
        component: () => import('@/views/Produtos/ProdutoMidias.vue'),
        props: true,
        meta: { title: 'Gerenciar Mídias', breadcrumb: 'Mídias' },
      },
      {
        path: ':id(\\d+)/requisitos',
        name: 'ProdutoRequisitos',
        component: () => import('@/views/Produtos/ProdutoRequisitos.vue'),
        props: true,
        meta: { title: 'Gerenciar Requisitos', breadcrumb: 'Requisitos' },
      },
      {
        path: ':id(\\d+)/downloads',
        name: 'ProdutoDownloads',
        component: () => import('@/views/Produtos/ProdutoDownloads.vue'),
        props: true,
        meta: { title: 'Gerenciar Downloads', breadcrumb: 'Downloads' },
      },
    ],
  },
];

export default produtosRoutes;
